// extracted by mini-css-extract-plugin
module.exports = {"addButton":"src-components-flowable-IRBStudy-StudyTable___addButton"};